<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.9721 13.3031L17.5169 8.66872C18.8664 4.62018 19.5412 2.5959 18.4726 1.52735C17.4041 0.458819 15.3798 1.13358 11.3313 2.48309L6.69689 4.02789C3.42931 5.11708 1.79553 5.66167 1.33126 6.46028C0.889581 7.22001 0.889581 8.15832 1.33126 8.91802C1.79553 9.71668 3.42931 10.2613 6.69689 11.3504C7.22154 11.5253 7.48387 11.6128 7.70314 11.7596C7.91564 11.9018 8.09819 12.0844 8.24041 12.2969C8.3872 12.5161 8.47468 12.7785 8.64955 13.3031C9.73873 16.5707 10.2833 18.2045 11.082 18.6687C11.8417 19.1104 12.78 19.1104 13.5397 18.6687C14.3384 18.2045 14.883 16.5707 15.9721 13.3031Z" stroke="white"/>
<path d="M13.0825 7.15869L8.79932 11.394L8.55225 11.146L12.8354 6.91064L13.0825 7.15869Z" fill="#1C274C" stroke="white"/>
</svg>
</template>

<script>
export default {
  name: 'IconSend'
}
</script>
